import ClassSearchabilityCheckbox, {
  SetClassVisibilityMutationFn,
} from './ClassSearchabilityCheckbox';
import React from 'react';
import { isNil } from 'lodash';
import { ClassSearchability } from 'globalTypes';

const ClassSearchabilityContainer = ({
  classSearchabilityFromBackend,
  classSearchabilitySchoolDefault,
  groupUuid,
  classSearchabilityEnabled,
  setClassSearchabilityEnabled,
  disabled,
}: {
  classSearchabilityFromBackend: string;
  classSearchabilitySchoolDefault: string;
  groupUuid: string | null | undefined;
  classSearchabilityEnabled: ClassSearchability | string | null | undefined;
  setClassSearchabilityEnabled: (searchability: ClassSearchability) => void;
  disabled: boolean;
}) => {
  const checked = isNil(classSearchabilityEnabled)
    ? classSearchabilityFromBackend === 'searchable'
    : classSearchabilityEnabled === 'searchable' ||
      classSearchabilityEnabled === ClassSearchability.searchable;

  return (
    <ClassSearchabilityCheckbox
      checked={checked}
      classSearchabilitySchoolDefault={classSearchabilitySchoolDefault}
      disabled={disabled}
      onChange={(event, classSearchabilityMutation: SetClassVisibilityMutationFn) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'checked' does not exist on type 'EventTa... Remove this comment to see the full error message
        const searchability = event.target.checked
          ? ClassSearchability.searchable
          : ClassSearchability.unsearchable;
        if (groupUuid) {
          classSearchabilityMutation({
            variables: { uuid: groupUuid, input: { searchability } },
          });
        }
        setClassSearchabilityEnabled(searchability);
      }}
    />
  );
};

export default ClassSearchabilityContainer;
